import { IBlacklistUrls } from "@/types";

const Blacklist: IBlacklistUrls[] = [
    {
        id: "1",
        created_at: "2024-01-06T04:25:52.279473+00:00",
        find: "onlyfans.com",
        content_warning: true,
        reason: "",
    },
    {
        id: "2",
        created_at: "2024-01-06T04:31:13.05378+00:00",
        find: "fansly.com",
        content_warning: true,
        reason: "",
    },
    {
        id: "3",
        created_at: "2024-10-28T11:43:25.970641+00:00",
        find: "chaturbate.com",
        content_warning: true,
        reason: "",
    },
];
export default Blacklist;
